import "./Loader.scss";

const Loader = () => {
    return(
        <section className="loader_card">
        <div className="outer"></div>
        <div className="inner"></div>
      </section>
    )
};

export default Loader;